/*  Used to add remove a class from an element when the viewport is between two
    other elements

    Add the class js-active-between to an html element you want to toggle

    Add the data attributes `above` and `below`, containing the css identifiers
    (only works with classes) you want the element to be active between

    Add the data attribute `class` to designate the class you would like to
    prepend to the --active modifier
*/

const init = (element) => {
  const below = document.querySelector(`.${element.dataset.below}`)
  const above = document.querySelector(`.${element.dataset.above}`)
  const cssClass = element.dataset.class

  const onScroll = () => {
    const isSticky =
      (!below || below.getBoundingClientRect().bottom < 0) &&
      (!above || above.getBoundingClientRect().top - window.innerHeight > 0)

    const action = isSticky ? "add" : "remove"
    element.classList[action](`${cssClass}--active`)
  }

  window.addEventListener("scroll", onScroll)

  onScroll()
}

document.querySelectorAll(".js-active-between").forEach(init)
